import {Image} from "antd";
import React from "react";


const AppImage = ({ src, className,  ...rest}) =>{
  return <Image
    preview={false}
    fallback={"/images/default-icon.svg"}
    className={className}
    src={src}
    {...rest}
  ></Image>;
};

export default AppImage;
